import { cn } from '@/utils/cn';

export interface SkipLinkProps {
  /** Already localized. */
  label: string;
  href?: string;
}

/**
 * First focusable element in the document. Visually hidden until focused, then a real control at
 * the start of the tab order so keyboard users skip the header chrome.
 */
export function SkipLink({ label, href = '#main-content' }: SkipLinkProps) {
  return (
    <a
      href={href}
      className={cn(
        'bg-primary text-on-primary sr-only focus:not-sr-only',
        'focus:absolute focus:start-4 focus:top-4 focus:z-50',
        'focus:rounded-lg focus:px-4 focus:py-2 focus:text-sm focus:font-medium',
        'focus-visible:ring-focus-ring focus-visible:ring-2 focus-visible:ring-offset-2',
        'focus-visible:ring-offset-background',
      )}
    >
      {label}
    </a>
  );
}
